
import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { initiateLogin } from '@/lib/api/auth';
import { Loader2, ExternalLink } from 'lucide-react';
import { toast } from 'sonner';

export const AuthLoginPage: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = async () => {
    setIsLoading(true);
    try {
      const { loginUrl } = await initiateLogin();
      window.open(loginUrl, '_blank');
      toast.info('Please complete the login in your browser. This page will update automatically.');
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : 'An unknown error occurred.';
      toast.error(`Login failed: ${errorMessage}`);
      setIsLoading(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-background p-8 text-center">
      <h1 className="text-3xl font-bold text-foreground">Authentication Required</h1>
      <p className="mt-4 max-w-2xl text-lg text-muted-foreground">
        To use Repoburg, you need to authenticate your device with your repoburg.com account.
      </p>

      <Button
        onClick={handleLogin}
        disabled={isLoading}
        className="mt-8"
        size="lg"
      >
        {isLoading ? (
          <Loader2 className="mr-2 h-5 w-5 animate-spin" />
        ) : (
          <ExternalLink className="mr-2 h-5 w-5" />
        )}
        {isLoading ? 'Waiting for browser...' : 'Login with repoburg.com'}
      </Button>

      {isLoading && (
        <p className="mt-4 text-sm text-muted-foreground">
            Once you complete authentication in your browser, this page will reload automatically.
        </p>
      )}
    </div>
  );
};